import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import { BackButton, EditIcon, PlusIcon } from "../assets/Icons";
import AddApplication from "../Modals/AddApplication";
import LauncherFiles from "../components/Application/LauncherFiles";
import apiClient from "../apiClient";
import { SSO_URL } from "../env";
import { GET_APP_WITH_DEFAULT_CONFIG } from "../apiClient/apiEndpoints";
import AddConfigurationMethod from "../Modals/AddConfigurationMethod";
import DefaultConfigList from "../components/Application/DefaultConfigList";

const ApplicationInfo = () => {
  const params = useParams();
  const { uuid } = params;
  const navigate = useNavigate();
  const [tabActiveKey, setTabActiveKey] = useState("var");
  const [openModal, setOpenModal] = useState(false);
  const [details, setDetails] = useState({});
  const [editApplicationModal, setEditApplicationModal] = useState(false);
  const handleChangeActiveKey = (selectedTab) => {
    setTabActiveKey(selectedTab);
  };

  const getApplicationDetails = async () => {
    try {
      let data = await apiClient(`${SSO_URL}${GET_APP_WITH_DEFAULT_CONFIG}/${uuid}`);
      setDetails(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getApplicationDetails();
  }, [uuid]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <>
      <div className="container-fluid m-0 pt-2 ">
        <div className="col-12">
          <button className="backbtn cursor-pointer mt-2" onClick={() => navigate(-1)} title="Back">
            <BackButton />
            Back
          </button>
        </div>

        <div className="col-12">
          <div className="application-main mt-3">
            <span className="application-logo">
              <img src={details?.icon || "https://cdn.simulanis.io/sso/logos/default_simulanis.png"} />
            </span>
            <div className="details-here">
              <span className="name-des">
                <span className="d-flex gap-1 mb-1 align-items-center justify-content-start">
                  <h6 className="m-0"> {details?.name || ""} </h6>
                  <span className="actionbtns ms-1">
                    <button className="btn btn-primary" style={{width:'2.5rem'}} onClick={() => setEditApplicationModal(true)}>
                      <EditIcon />
                    </button>
                  </span>
                </span>
                <p> {details?.description || ""} </p>
              </span>
              {/* <span className="tag-list">
                <p>06-06-24</p>
                <p>Active</p>
                <p>Quiz</p>
                <p>Chatbot</p>
              </span> */}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-10">
            <Tab.Container activeKey={tabActiveKey} defaultActiveKey="var" onSelect={handleChangeActiveKey}>
              <div className="row mt-3">
                <div className="tabanddown">
                  <Nav variant="pills" className="module-tab" defaultActiveKey="var">
                    <Nav.Item>
                      <Nav.Link eventKey="var">Configurations</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="launcher">Launcher File</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>

              <Tab.Content className="mt-3 mb-4">
                <Tab.Pane eventKey="var">
                  <DefaultConfigList applicationId={uuid} />
                </Tab.Pane>

                <Tab.Pane eventKey="launcher">
                  <LauncherFiles />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>

          <div className="col-2">
            <button className="addMethodBtn" onClick={handleOpenModal}>
              <PlusIcon />
              Add Template
            </button>
          </div>
        </div>
      </div>

      <AddApplication
        applicationModal={editApplicationModal}
        setApplicationModal={setEditApplicationModal}
        editMode={true}
        applicationData={details}
        refresh={getApplicationDetails}
        applicationList={[]}
      />

      <AddConfigurationMethod applicationId={uuid} openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
};

export default ApplicationInfo;
